// extracted by mini-css-extract-plugin
module.exports = {"container":"ReturnPoliciesPage_container__q15fR","item":"ReturnPoliciesPage_item__3X9Y1"};